import * as React from 'react';
import { TextField } from '@mui/material';

interface Props {
  name: string;
  value: string;
  error: string | null;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export default function ContactEmailField({
  name,
  value,
  error,
  placeholder = 'name@example.com',
  autoFocus,
  disabled,
  onChange,
  onBlur,
}: Props) {
  return (
    <TextField
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      type="email"
      inputMode="email"
      autoComplete="email"
      autoFocus={autoFocus}
      disabled={disabled}
      fullWidth
      error={!!error}
      helperText={error || undefined}
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-root': {
          height: 48,
          borderRadius: '12px',
          backgroundColor: '#FFFFFF',
          fontFamily: 'Montserrat, sans-serif',
          lineHeight: '24px',
          color: 'text.primary',
          typography: 'body2',
        },
        '& .MuiOutlinedInput-input': {
          padding: '0 16px',
          height: '100%',
          boxSizing: 'border-box',
        },
        '& .MuiOutlinedInput-input::placeholder': {
          color: 'text.tertiary',
          opacity: 1,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(20, 18, 15, 0.14)',
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(20, 18, 15, 0.3)',
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
          {
            borderColor: '#FF3008',
            borderWidth: '1.5px',
          },
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: '#FF3008',
        },
        '& .MuiFormHelperText-root': {
          marginTop: '4px',
          marginLeft: '4px',
          fontSize: 'caption.fontSize',
          lineHeight: 1.2,
        },
      }}
    />
  );
}
